import { render, staticRenderFns } from "./sign-up-purchase-list.html?vue&type=template&id=27e3c5a6&scoped=true&external"
import script from "./sign-up-purchase-list.js?vue&type=script&lang=js&external"
export * from "./sign-up-purchase-list.js?vue&type=script&lang=js&external"
import style0 from "./sign-up-purchase-list.scss?vue&type=style&index=0&id=27e3c5a6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e3c5a6",
  null
  
)

export default component.exports